import SpriteSymbol from "../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ic_circle_check",
  "use": "ic_circle_check-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"ic_circle_check\">\n    <path d=\"M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M17.8863636,7 L9.45454545,14.9983416 L6.11363636,11.8291874 L5,12.8855721 L9.45454545,17.1111111 L19,8.05638474 L17.8863636,7 Z\" id=\"ic_circle_check_path-1\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol